var WindowResize = function () {
    var resize = function () {
        var navHeight = $("nav").outerHeight();
        var content = $("main");
        var footerHeight = $("footer").outerHeight();

        var sum = navHeight + footerHeight;
        content.css("min-height", "100vh").css('min-height', '-=' + sum + 'px');
    };

    var init = function () {
        $(window).resize(function () {
            resize();
        });
    };

    return {
        init: function () {
            init();
            resize();
        }
    };
}();

var Alert = function () {
    var hide_alert_box = function () {
        $(function () {
            $("[data-hide]").on("click", function () {
                $(this).closest("." + $(this).attr("data-hide")).hide();
            });
        });
    };

    var fade_alert_box = function () {
        $(function () {
            $("[data-fade]").on("click", function () {
                var alert = $(this).closest("." + $(this).attr("data-fade"));
                alert.slideUp(500);
            });
        });
    };

    return {
        init: function () {
            hide_alert_box();
            fade_alert_box();
        }
    }
}();

var BackToTop = function () {
    var self = {
        selector: "#back-to-top",
        initButton: function () {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $(self.selector).fadeIn();
                } else {
                    $(self.selector).fadeOut();
                }
            });
        },
        initClick: function () {
            $(self.selector).click(function () {
                $(self.selector).tooltip('hide');
                $('body,html').animate({
                    scrollTop: 0
                }, 800);
                return false;
            });
        },
        init: function () {
            self.initButton();
            self.initClick();
        }
    };
    return {
        init: function () {
            self.init();
        }
    }
}();

var BackToTop = function () {
    var self = {
        selector: "#back-to-top",
        initButton: function () {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $(self.selector).fadeIn();
                } else {
                    $(self.selector).fadeOut();
                }
            });
        },
        initClick: function () {
            $(self.selector).click(function () {
                $(self.selector).tooltip('hide');
                $('body,html').animate({
                    scrollTop: 0
                }, 800);
                return false;
            });
        },
        init: function () {
            self.initButton();
            self.initClick();
        }
    };
    return {
        init: function () {
            self.init();
        }
    }
}();

var CoverImage = function () {
    var self = {
        selector: ".cover-image",
        init: function () {
            let $delay = $('body').attr('data-delay');

            if (isNaN($delay)) {
                $delay = 3000;
            }

            setTimeout(() => {
                $(self.selector).each(function () {
                    var $this = $(this);
                    let originalImage = $this.attr('data-image');

                    if (typeof originalImage == 'undefined') {
                        return;
                    }

                    $this.removeClass('animate-pulse');

                    if ($this.is('img')) {
                        $this.attr('src', originalImage);
                    } else {
                        $this.css('background-image', 'url(' + originalImage + ')');
                    }
                });
            }, $delay);
        },
    };
    return {
        init: function () {
            self.init();
        }
    }
}();

var BodyOverlay = function () {
    var self = {
        selector: "#body-overlay",
        init: function () {
            $(self.selector).hide();
        },
    };
    return {
        init: function () {
            self.init();
        }
    }
}();

$(document).ready(function () {
    Alert.init();
    // WindowResize.init();
    BackToTop.init();
    BodyOverlay.init();
    CoverImage.init();
});
